// Paso 2 "Mi contacto" del formulario de inscripción rediseñado (v2).
// Mismas props (props_c) que InscripcionAgregarMiContacto; solo cambia la presentación.
import React from "react";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import HomeIcon from "@material-ui/icons/Home";
import LocalHospitalIcon from "@material-ui/icons/LocalHospital";
import BuscarSelect from "../../general/BuscarSelect";
import { EPS_OTRO } from "../helper";
import { useEstilosInscripcion } from "./estilosInscripcion";
import { Seccion, columnas } from "./componentesInscripcion";

export default function PasoMiContacto({ props_c }) {
  const classes = useEstilosInscripcion();
  let {
    departamentos, departamento, setDepartamento, ciudades, ciudad, setCiudad, estratos, estrato, setEstrato,
    onChange, barrio, direccion, opcionesEps, nombreEps, setNombreEps, nombreEpsOtro, mostrar_ciudades,
    canales_contacto, canal_contacto, setCanalContacto, campo_error,
  } = props_c;

  // Campo marcado en rojo tras "Continuar" (campo_error lo define validarDatos en InscripcionAgregar)
  const err = (campo) => campo_error === campo;
  const marca = (campo) => (err(campo) ? { "data-error": "true" } : {});
  const claseSelect = (campo) => `${classes.campoSelect} ${err(campo) ? classes.campoSelectError : ""}`;

  const conEpsOtra = nombreEps && nombreEps.value === EPS_OTRO;
  const totalSalud = conEpsOtra ? 3 : 2;

  return (
    <React.Fragment>
      <p className={classes.tituloPaso}>¿Dónde te encontramos?</p>
      <p className={classes.descripcionPaso}>Los campos con * son obligatorios.</p>

      <Seccion icono={HomeIcon} titulo="Lugar de residencia">
        <Grid item {...marca("departamento")} {...columnas(0, 5)}>
          <div className={claseSelect("departamento")}><BuscarSelect datos={departamentos} cambiarEstado={(value) => setDepartamento(value)} valor={departamento} id="select-departamento" nombre="Departamento" placeholder="Seleccione departamento" /></div>
        </Grid>
        <Grid item {...marca("ciudad")} {...columnas(1, 5)}>
          <div className={claseSelect("ciudad")}><BuscarSelect datos={ciudades} cambiarEstado={(value) => setCiudad(value)} valor={ciudad} id="select-ciudad" nombre="Ciudad o municipio" placeholder={mostrar_ciudades ? "Seleccione ciudad" : "Cargando información, por favor espere..."} habilitado={mostrar_ciudades ? true : false} /></div>
        </Grid>
        <Grid item {...marca("barrio")} {...columnas(2, 5)}>
          <TextField error={err("barrio")} value={barrio} onChange={onChange} name="barrio" required id="barrio" label="Barrio" fullWidth />
        </Grid>
        <Grid item {...marca("direccion")} {...columnas(3, 5)}>
          <TextField error={err("direccion")} value={direccion} onChange={onChange} name="direccion" required id="direccion" label="Dirección de residencia" fullWidth autoComplete="address-line1" />
        </Grid>
        <Grid item {...marca("estrato")} {...columnas(4, 5)}>
          <div className={claseSelect("estrato")}><BuscarSelect datos={estratos} cambiarEstado={(value) => setEstrato(value)} valor={estrato} id="select-estrato" nombre="Estrato" placeholder="Seleccione estrato" /></div>
        </Grid>
      </Seccion>

      <Seccion icono={LocalHospitalIcon} titulo="Salud y contacto">
        <Grid item {...marca("nombreEps")} {...columnas(0, totalSalud)}>
          <div className={claseSelect("nombreEps")}><BuscarSelect datos={opcionesEps} cambiarEstado={(value) => setNombreEps(value)} valor={nombreEps} id="select-eps" nombre="EPS" placeholder="Seleccione EPS" /></div>
        </Grid>
        {conEpsOtra && (
          <Grid item {...marca("nombreEpsOtro")} {...columnas(1, totalSalud)}>
            <TextField error={err("nombreEpsOtro")} value={nombreEpsOtro} required id="nombre_eps" name="nombreEpsOtro" label="Nombre de la EPS" fullWidth onChange={onChange} />
          </Grid>
        )}
        <Grid item {...marca("canal_contacto")} {...columnas(conEpsOtra ? 2 : 1, totalSalud)}>
          <div className={claseSelect("canal_contacto")}><BuscarSelect datos={canales_contacto} cambiarEstado={(value) => setCanalContacto(value)} valor={canal_contacto} id="select-canal-contacto" nombre="Canal de contacto preferido" placeholder="Seleccione canal" /></div>
        </Grid>
      </Seccion>
    </React.Fragment>
  );
}
